import Swiper, { Navigation, Pagination, Autoplay, Controller, Lazy } from 'swiper';

import '../styles/index.scss'
import '../styles/new-pages.scss'

import './common/twinspark'
import './common/popup-banner'
import './common/header'

document.addEventListener("DOMContentLoaded", () => {
  if (document.getElementById("index-slider")) {
    new Swiper("#index-slider", {
      modules: [Navigation, Pagination, Autoplay, Controller, Lazy],
      autoplay: {
        delay: 3000,
        pauseOnMouseEnter: true,
      },
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: "#index-slider .swiper-pagination",
        clickable: true,
      },
    })
  }
})

document.addEventListener("ProductListLoaded", () => {
  if (document.querySelectorAll(".product-slider").length) {
    new Swiper(".product-slider", {
      modules: [Navigation, Pagination, Autoplay, Controller, Lazy],
      spaceBetween: 15,
      slidesPerView: 1,
      pagination: {
        el: '.swiper__dots',
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        476: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
        },
        1200: {
          slidesPerView: 5,
        },
      },
    })
  }

})

document.addEventListener("PortfolioListLoaded", () => {
  if (document.querySelectorAll(".portfolio-slider").length) {
    new Swiper(".portfolio-slider", {
      modules: [Navigation, Pagination, Autoplay, Controller, Lazy],
      spaceBetween: 15,
      lazy: {
        loadPrevNext: true,
      },
      loop: true,
      watchOverflow: true,
      autoplay: {
        delay: 3000,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: '.swiper__dots',
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2
        },
        1200: {
          slidesPerView: 3,
        },
      },
    })
  }
})
